import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../../../../components/card";
import { Column, Row } from "../../../../components/flex/styled";
import { H3, P, Span } from "../../../../components/typography/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import { Layout } from "../../../../containers/app/layout";
import { PaymentModal } from "../../../../containers/app/modals/paymentmodal";
import { WalletFundingModal } from "../../../../containers/app/modals/walletfundingmodal";
import { Context } from "../../../../context";
import { getWalletInfo } from "../../../../utils/apis/wallet/getWalletInfo";
import Cookies from "universal-cookie";
import { WalletWrapper } from "./styled";

export const Wallet = () => {
  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");
  const COMPANY_ID = cookies.get("COMPANY_ID");

  const {
    setIsWalletFundingModalOpen,
    walletRefreshTrigger,
    activeCompanyDetails,
  } = useContext(Context);

  const navigate = useNavigate();

  useEffect(() => {
    // Route Guard: If data is loaded and plan is not premium, boot them to dashboard
    if (activeCompanyDetails && activeCompanyDetails.payrollPlan?.toLowerCase() !== "premium") {
      navigate("/dashboard", { replace: true });
    }
  }, [activeCompanyDetails, navigate]);

  const [wallet, setWallet] = useState({});
  const [isWalletLoading, setIsWalletLoading] = useState(true);

  useEffect(() => {
    setIsWalletLoading(true);
    getWalletInfo(TOKEN, COMPANY_ID)
      .then((data) => setWallet(data || {}))
      .catch((err) => {
        console.error("Failed to fetch wallet info:", err);
      })
      .finally(() => setIsWalletLoading(false));
    // Refetches after a successful complete-funding call, since that
    // endpoint doesn't return the updated balance itself.
  }, [TOKEN, COMPANY_ID, walletRefreshTrigger]);


  const handleOpenWalletFundingModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsWalletFundingModalOpen(true);
  };

  const formatCurrency = (value) =>
    `\u20a6${Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  // TODO: Transaction history table placeholder.
  // Once a backend endpoint for employer wallet transaction history is available,
  // add a <Table location="Wallet Table" ... /> here using the shared Table component.
  // The table case and row template will also need to be added in src/components/table/index.js.

  return (
    <Layout
      id={"wallet"}
      title={"Wallet"}
      location={"wallet"}
      callToAction={"Fund Wallet"}
      handleCallToActionClick={handleOpenWalletFundingModal}
    >
      <WalletWrapper>
        <Row className="cards-group">
          <Card className={"wallet-balance-card"}>
            <Row
              alignitems={"center"}
              justifycontent={"space-between"}
              className="card-body-introduction"
            >
              <Column gap={"0.1rem"}>
                <P className="card-title">Cash Wallet</P>
                <H3>Available Balance</H3>
              </Column>
              <FontAwesomeIcon icon={faWallet} size="2x" color="var(--color-primary)" />
            </Row>
            <div className="card-body">
              <P>
                <Span>{isWalletLoading ? "..." : formatCurrency(wallet?.balance)}</Span>
              </P>
              {wallet?.dateOfLastFunding && (
                <P className="card-meta">
                  Last funded {wallet.dateOfLastFunding}
                </P>
              )}
            </div>
            <div className="card-body">
              {/* <P>
                Add Funds to your wallet to run payroll for your employees.
              </P> */}
              <></>
              <button
                className="fund-button"
                onClick={handleOpenWalletFundingModal}
              >
                Fund Wallet
              </button>
            </div>
          </Card>
        </Row>

        {/* TODO: Transaction history table placeholder */}
      </WalletWrapper>
      <PaymentModal />
      <WalletFundingModal />
    </Layout>
  );
};
